export class ImportFileClearHandler {
    /**
     * File inputs never carry a server-rendered value (browsers never
     * repopulate <input type="file"> across a GET reload), so the clear
     * button only ever needs to react to what the user just picked in this
     * page's lifetime — show it once a file is selected, hide it once
     * cleared.
     */
    public applyVisibility(input: HTMLInputElement, button: HTMLButtonElement): void {
        button.classList.toggle("show", input.files !== null && input.files.length > 0);
    }

    public clear(input: HTMLInputElement, button: HTMLButtonElement): void {
        input.value = "";
        this.applyVisibility(input, button);
    }
}
